import React from 'react';
import Icon from '../components/AppIcon';
import { useERPTheme } from '../utils/theme';

const Configuracion = () => {
  const { theme, setTheme } = useERPTheme();

  const options = [
    {
      id: 'dark',
      label: 'Modo oscuro',
      description: 'La apariencia actual del ERP. Ideal para trabajar con poca luz y mantiene la identidad visual oscura.',
      icon: 'Moon',
    },
    {
      id: 'light',
      label: 'Modo claro',
      description: 'Fondo claro y mayor contraste para trabajar con mucha iluminación.',
      icon: 'Sun',
    },
  ];

  return (
    <div className="min-h-screen px-4 py-6 lg:px-8 lg:py-8">
      <div className="mx-auto max-w-5xl">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-[#D6EF4E]/25 bg-[#D6EF4E]/10">
              <Icon name="Settings" size={24} className="text-[#D6EF4E]" />
            </div>
            <div>
              <h1 className="erp-page-title">Configuración</h1>
              <p className="erp-page-subtitle">Preferencias generales del ERP</p>
            </div>
          </div>
        </div>

        <section className="rounded-2xl border border-white/10 bg-white/[0.025] p-5 shadow-xl lg:p-7">
          <div className="mb-6 flex items-start justify-between gap-4">
            <div>
              <div className="flex items-center gap-2 mb-1">
                <Icon name="Palette" size={20} className="text-[#D6EF4E]" />
                <h2 className="erp-section-title">Apariencia</h2>
              </div>
              <p className="erp-secondary-text">
                Elige cómo quieres visualizar Las Dos Doncellas ERP. El cambio se aplica inmediatamente y queda guardado.
              </p>
            </div>

            <span className="hidden rounded-full border border-[#D6EF4E]/25 bg-[#D6EF4E]/10 px-3 py-1 text-sm text-[#D6EF4E] sm:inline-flex">
              {theme === 'dark' ? 'Oscuro activo' : 'Claro activo'}
            </span>
          </div>

          <div className="grid gap-4 md:grid-cols-2">
            {options.map((option) => {
              const active = theme === option.id;

              return (
                <button
                  key={option.id}
                  type="button"
                  onClick={() => setTheme(option.id)}
                  className={`group rounded-2xl border p-5 text-left transition-all duration-200 ${
                    active
                      ? 'border-[#D6EF4E]/60 bg-[#D6EF4E]/10 shadow-lg shadow-[#D6EF4E]/5'
                      : 'border-white/10 bg-white/[0.02] hover:border-white/20 hover:bg-white/[0.04]'
                  }`}
                >
                  <div className="flex items-center justify-between gap-4">
                    <div className={`flex h-12 w-12 items-center justify-center rounded-xl border ${
                      active
                        ? 'border-[#D6EF4E]/40 bg-[#D6EF4E]/15 text-[#D6EF4E]'
                        : 'border-white/10 bg-white/5 text-white/60'
                    }`}>
                      <Icon name={option.icon} size={23} />
                    </div>

                    <div className={`flex h-6 w-6 items-center justify-center rounded-full border ${
                      active
                        ? 'border-[#D6EF4E] bg-[#D6EF4E]'
                        : 'border-white/20 bg-transparent'
                    }`}>
                      {active && <Icon name="Check" size={15} className="text-black" />}
                    </div>
                  </div>

                  <h3 className="mt-5 text-xl font-semibold text-white">{option.label}</h3>
                  <p className="mt-2 text-base leading-relaxed text-white/55">{option.description}</p>
                </button>
              );
            })}
          </div>

          <div className="mt-6 flex items-center gap-3 rounded-xl border border-white/8 bg-black/10 px-4 py-3">
            <Icon name="Info" size={18} className="flex-shrink-0 text-white/45" />
            <p className="text-sm text-white/50">
              La preferencia se guarda en este dispositivo y se mantiene al cambiar de página.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Configuracion;
